import React from "react";
import styles from "./Header.module.scss";
export const Header = ({
  title,
  size,
  padding,
  children,
  className,
}: {
  title?: React.ReactNode;
  size?: string;
  padding?: string;
  children?: React.ReactElement;
  className?: string;
}) => {
  return (
    <header
      className={`${styles.header} ${className ? className : ""}`}
      style={{ padding: padding }}
    >
      <h1 className={styles.title} style={{ fontSize: size }}>
        {children}
        {title}
      </h1>
    </header>
  );
};
